var map = {
	"./Digital/Home/Article1": [
		1,
		9
	],
	"./Digital/Home/Article1.js": [
		1,
		9
	],
	"./Digital/Home/articles": [
		917,
		3
	],
	"./Digital/Home/articles.json": [
		917,
		3
	],
	"./Digital/Home/cards/AFFICHE ARTICLE-7.jpg": [
		104,
		1
	],
	"./MiddleSchool/Grade6/Article1": [
		455,
		9
	],
	"./MiddleSchool/Grade6/Article1.js": [
		455,
		9
	],
	"./MiddleSchool/Grade6/articles": [
		587,
		3
	],
	"./MiddleSchool/Grade6/articles.json": [
		587,
		3
	],
	"./MiddleSchool/Grade6/cards/AFFICHE ARTICLE-9.jpg": [
		673,
		1
	],
	"./MiddleSchool/Grade6/cards/Article1.jpeg": [
		487,
		1
	],
	"./MiddleSchool/Grade6/cards/Article2.jpeg": [
		475,
		1
	],
	"./MiddleSchool/Grade7/Article1": [
		702,
		9
	],
	"./MiddleSchool/Grade7/Article1.js": [
		702,
		9
	],
	"./MiddleSchool/Grade7/articles": [
		55,
		3
	],
	"./MiddleSchool/Grade7/articles.json": [
		55,
		3
	],
	"./MiddleSchool/Grade7/cards/AFFICHE ARTICLE-10.jpg": [
		674,
		1
	],
	"./MiddleSchool/Grade7/cards/Article1.jpeg": [
		352,
		1
	],
	"./MiddleSchool/Grade7/cards/Article2.jpeg": [
		712,
		1
	],
	"./MiddleSchool/Grade8/Article1": [
		436,
		9
	],
	"./MiddleSchool/Grade8/Article1.js": [
		436,
		9
	],
	"./MiddleSchool/Grade8/articles": [
		209,
		3
	],
	"./MiddleSchool/Grade8/articles.json": [
		209,
		3
	],
	"./MiddleSchool/Grade8/cards/AFFICHE ARTICLE-11.jpg": [
		918,
		1
	],
	"./MiddleSchool/Grade8/cards/Article1.jpeg": [
		958,
		1
	],
	"./MiddleSchool/Grade8/cards/Article2.jpeg": [
		286,
		1
	],
	"./MiddleSchool/Home/Article2": [
		124,
		9
	],
	"./MiddleSchool/Home/Article2.js": [
		124,
		9
	],
	"./MiddleSchool/Home/articles": [
		130,
		3
	],
	"./MiddleSchool/Home/articles.json": [
		130,
		3
	],
	"./MiddleSchool/Home/cards/AFFICHE ARTICLE-12.jpg": [
		766,
		1
	],
	"./MiddleSchool/Home/cards/backtoschool_notebook.svg": [
		274,
		1
	],
	"./TeacherPaper/Home/Article1": [
		967,
		9
	],
	"./TeacherPaper/Home/Article1.js": [
		967,
		9
	],
	"./TeacherPaper/Home/Article2": [
		780,
		9
	],
	"./TeacherPaper/Home/Article2.js": [
		780,
		9
	],
	"./TeacherPaper/Home/articles": [
		509,
		3
	],
	"./TeacherPaper/Home/articles.json": [
		509,
		3
	],
	"./TeacherPaper/Home/cards/AFFICHE ARTICLE-8.jpg": [
		456,
		1
	],
	"./TeacherPaper/Home/cards/Article1.jpeg": [
		135,
		1
	],
	"./TeacherPaper/Home/cards/Article2.jpeg": [
		554,
		1
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 687;
module.exports = webpackAsyncContext;